import { LOGIN, SEND_TFA_CODE_TO_EMAIL, SEND_TWO_FA_CODE, TWO_FACTOR_AUTH, VERIFY_PHONE } from "./constants";

export function loginAction(payload, callback) {
  return {
    type: LOGIN,
    payload,
    callback,
  };
}

export function twoFactor(payload) {
  return {
    type: TWO_FACTOR_AUTH,
    payload,
  };
}

export function phoneVerify(payload) {
  return {
    type: VERIFY_PHONE,
    payload,
  };
}

export function resendTwoFactorCode(payload) {
  return {
    type: SEND_TWO_FA_CODE,
    payload,
  };
}

export function twoFactorCodeToEmail(payload) {
  return {
    type: SEND_TFA_CODE_TO_EMAIL,
    payload,
  };
}
